import { Box, Button, Grid, Stack, Typography } from "@mui/material";
import React from "react";
import { PortableText } from "@portabletext/react";
import urlBuilder from "@sanity/image-url";
import { navigate } from "gatsby";
import ArrowForward from "@mui/icons-material/ArrowForward";
import COLORS from "../../../constants/colors";
import { Campaign } from "../../../interfaces/sanity/sanityClasses";
import sanity from "../../../constants/sanity";

interface Props {
  activeCampaign: Campaign;
  multipleActiveCampaigns: boolean;
}
const CampaignShowCaseCard = ({
  activeCampaign,
  multipleActiveCampaigns,
}: Props) => {
  const typographyColor = COLORS.BLACK[100];

  const components = {
    block: {
      // eslint-disable-next-line @typescript-eslint/no-shadow, react/no-unstable-nested-components, @typescript-eslint/no-explicit-any
      normal: ({ children }: any) => (
        <Typography variant="body" color={typographyColor}>
          {children}
        </Typography>
      ),
    },
  };

  return (
    <Grid
      xs
      item
      bgcolor={
        activeCampaign.campaignTitle === "Vi tar støtet"
          ? COLORS.YELLOW[39]
          : COLORS.WHITE[100]
      }
      borderRadius="20px"
      p={{ xs: "24px", md: multipleActiveCampaigns ? "48px" : "110px" }}
      display="flex"
      flexDirection={{
        xs: "column-reverse",
        md: multipleActiveCampaigns ? "column-reverse" : "row",
      }}
      justifyContent="flex-end"
      alignItems={multipleActiveCampaigns ? "stretch" : "center"}
      gap="48px"
    >
      <Stack height="100%">
        <Stack
          spacing="24px"
          height="100%"
          justifyContent="space-between"
          alignItems="flex-start"
        >
          <Stack spacing="24px">
            <Stack>
              <Typography
                color={COLORS.BRIGHT_BLUE[100]}
                sx={{
                  textTransform: "capitalize",
                }}
              >
                {activeCampaign.publishedAt}
              </Typography>
              <Typography
                fontFamily="erlik"
                variant="h2"
                color={typographyColor}
              >
                {activeCampaign.campaignTitle}
              </Typography>
            </Stack>
            <PortableText
              value={activeCampaign._rawCampaignLead}
              components={components}
            />
          </Stack>
          <Box alignItems="flex-start">
            <Button
              onClick={() => {
                navigate(`/gjeldfri/${activeCampaign.slug.current}`);
              }}
              color="dark"
              variant="contained"
              endIcon={<ArrowForward />}
            >
              Se kampanje
            </Button>
          </Box>
        </Stack>
      </Stack>
      <Stack minWidth="55%">
        <Stack width="100%">
          <Stack
            component="img"
            src={urlBuilder()
              .image(activeCampaign.thumbnailImage)
              .projectId(sanity.PROJECT_ID)
              .dataset("blogg")
              .fit("fill")
              .format("webp")
              .auto("format")
              .quality(100)
              .width(512)
              .height(320)
              .url()}
            alt={activeCampaign.campaignTitle}
            sx={{
              width: "100%",
              aspectRatio: "1.6",
              objectFit: "cover",
              borderRadius: "20px",
            }}
          />
        </Stack>
      </Stack>
    </Grid>
  );
};
export default CampaignShowCaseCard;
